import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../theme/ISpcTheme';

export type DisclaimerClasses = 'wrapper' | 'postcode' | 'disclaimerTitle';

const disclaimersSectionStyles = makeStyles<ISpcTheme, DisclaimerClasses>(
  ({ palette }) => ({
    wrapper: {
      margin: '10px 0',
      padding: '30px 10px 10px 10px',
      borderRadius: '0 0 10px 10px',
      borderTop: `2px solid ${palette.primaryDisabled.main}`,
    },
    postcode: {
      color: palette.primary.main,

      '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    },
    disclaimerTitle: {
      fontWeight: 'bold',
      display: 'block',
      marginBottom: '10px',
    },
  }),
  { name: 'ProductCatalog_Disclaimers' },
);

export default disclaimersSectionStyles;
